import { CancelToken } from 'axios'

import { TableUrlParams } from 'Core/interfaces'
import { Http } from 'Core/utils'

import { Mou } from 'Portals/Customer/entities'

import { baseUrl } from './constants'

export const getList = (params: TableUrlParams): Promise<{ items: Mou.Basic[]; total: number }> =>
	Http.get(baseUrl, { params })

export const downloadMou = (mouId: Key): Promise<Blob> =>
	Http.get(`${baseUrl}/${mouId}/download`, {
		responseType: 'blob'
	})

export const searchSuggestions = (
	params: TableUrlParams,
	cancelToken?: CancelToken
): Promise<Mou.Search.Result> => Http.get(`${baseUrl}/search-suggestions`, { params, cancelToken })
